module.exports = __webpack_public_path__ + "src/img/aiEditorIconNew.b550cb4c.svg";